import { constants } from "./constants";

export function removeFromPath(path: string) {
  let matchedLocale = null;
  path = path.split('?')[0];
  const query = path.split('?')[1];
  const localeRegex = new RegExp(`^/?(${constants.locales.join("|")})\\b`, "i");
  const localeMatch = path.match(localeRegex);
  
  if (localeMatch) {
    matchedLocale = localeMatch[1];
  }

  const regex = new RegExp(`\\b(${[...constants.locales, ...constants.deviceTypes, ...constants.renderingTypes].join("|")})\\b`, "gi");
  let cleanedUrl = path.replace(regex, '').replace(/\/+/g, '/').replace(/\/$/, '');
  cleanedUrl = cleanedUrl.startsWith('/') ? cleanedUrl : '/' + cleanedUrl;

  return { cleanedUrl, locale: matchedLocale, query };
}